import React from 'react';
import { connect } from 'react-redux';

import { setAppointmentType } from '../../../../../../_actions/questionnaire.actions'

function AppointmentType({ appointmentType, setAppointmentType }) {
  const inOffice = appointmentType.extension.find((type) => {
    return type.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-axs-links';
  });

  const telehealth = appointmentType.extension.find((type) => {
    return type.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-telehealth';
  });

  return <div className="form-group">
    <label><span className="text-danger">*</span> <strong>Type</strong></label>

    <div className="form-check">
      <input
        onChange={(e) => { setAppointmentType(e.target.value) }}
        id={`appointment-type_axs-links`}
        name={`appointment-type`}
        checked={inOffice.valueBoolean}
        className="form-check-input"
        type='checkbox'
        value="axs-links" />
      <label
        htmlFor={`appointment-type_axs-links`}
        className="form-check-label">Form</label>
    </div>

    <div className="form-check">
      <input
        onChange={(e) => { setAppointmentType(e.target.value) }}
        id={`appointment-type_telehealth`}
        name={`appointment-type`}
        checked={telehealth.valueBoolean}
        className="form-check-input"
        type='checkbox'
        value="telehealth" />
      <label
        htmlFor={`appointment-type_telehealth`}
        className="form-check-label">Telehealth</label>
    </div>
  </div>
}

const mapStateToProps = (state) => {
  return {
    appointmentType: state.questionnaire.current.extension.find((extensionType) => {
      return extensionType.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-appointmentType';
    })
  }
}

const mapDispatchToProps = (dispatch) => {
  return { setAppointmentType: (type) => { dispatch(setAppointmentType(type)) } }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentType);